import { useState, useMemo } from 'react';
import { get } from 'lodash';

import {
  makeRequiredFieldsValidator,
  useFormState,
  useFormValidation,
} from '../../../hocs/useFormWithValidation';

import { PROFILE_FIELDS_TYPES } from '../../../constants/formFields';

export const initialState = {
  [PROFILE_FIELDS_TYPES.EMAIL]: '',
  [PROFILE_FIELDS_TYPES.PHONE_NUMBER]: '',
  [PROFILE_FIELDS_TYPES.ADDRESS_1]: '',
  [PROFILE_FIELDS_TYPES.COUNTRY]: '',
  [PROFILE_FIELDS_TYPES.CITY]: '',
  [PROFILE_FIELDS_TYPES.STATE]: '',
  [PROFILE_FIELDS_TYPES.POSTAL_CODE]: '',
};

export const validateRequiredFields = (isZipApplicable = true) =>
  makeRequiredFieldsValidator([
    PROFILE_FIELDS_TYPES.ADDRESS_1,
    PROFILE_FIELDS_TYPES.CITY,
    PROFILE_FIELDS_TYPES.STATE,
    ...(isZipApplicable && [PROFILE_FIELDS_TYPES.POSTAL_CODE]),
  ]);

export function useGeneralInfoFormState(data, errors, isZipApplicable) {
  const { formState, handleFormChange } = useFormState(initialState);
  const {
    validateErrors,
    clearErrors,
    addLocalValidateErrors,
  } = useFormValidation(errors);

  // todo: enhance is valid with validateErrors obj
  const isValid = validateRequiredFields(isZipApplicable)(formState);

  const setCountryValue = value => {
    handleFormChange({
      ...formState,
      [PROFILE_FIELDS_TYPES.COUNTRY]: value,
      [PROFILE_FIELDS_TYPES.STATE]: '',
      [PROFILE_FIELDS_TYPES.POSTAL_CODE]: '',
    });
  };

  return useMemo(
    () => ({
      formState,
      handleFormChange,
      validateErrors,
      addLocalValidateErrors,
      setCountryValue,
      clearErrors,
      isValid,
    }),
    [
      formState,
      handleFormChange,
      validateErrors,
      addLocalValidateErrors,
      setCountryValue,
      clearErrors,
      isValid,
    ],
  );
}

export function useAvatarState(state) {
  const [avatar, setAvatar] = useState(get(state, 'avatar.url', ''));
  const handleImageCrop = base64 => setAvatar(base64);
  const handleImageRemove = () => setAvatar('');

  return {
    avatar,
    handleImageCrop,
    handleImageRemove,
  };
}



// WEBPACK FOOTER //
// ./src/components/DependentForm/utils/useGeneralInfoFormState.js